import React, { useContext } from "react";
import "./css/app.scss";
import "fontsource-roboto/latin.css"; //needed for Material UI
import AuthenticatedApp from "./components/AuthenticatedApp";
import UnAuthenticatedApp from "./components/UnAuthenticatedApp";

import "./App.css";
import { AuthContext } from "./providers/AuthProvider";
import { SlidersProvider } from "./providers/SlidersProvider";

// import PdfTimesheet from "./components/PdfTimesheet";

function App() {
  let { user } = useContext(AuthContext);
  // console.log("user in app js", user);

  return (
    <div className="App">
      {/* {user ? <PdfTimesheet /> : <UnAuthenticatedApp />} */}
      {user?.uid ? (
        <SlidersProvider>
          <AuthenticatedApp />
        </SlidersProvider>
      ) : (
        <UnAuthenticatedApp />
      )}
    </div>
  );
}

export default App;
